var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.414 23.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-819 -977)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(828.432 995.358)",
    fill: "inherit",
    fontSize: 18,
    fontFamily: "Eurostile-Reg, Eurostile",
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(819 977)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.561,0l6.854,11.95L20.561,23.9H6.854L0,11.95,6.854,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.722497940063477 1.500003814697266 L 1.729202270507812 11.94985294342041 L 7.722497940063477 22.39970207214355 L 19.69186973571777 22.39970207214355 L 25.68516540527344 11.94985294342041 L 19.69186973571777 1.500003814697266 L 7.722497940063477 1.500003814697266 M 6.853593826293945 3.814697265625e-06 L 20.5607738494873 3.814697265625e-06 L 27.41436386108398 11.94985294342041 L 20.5607738494873 23.89970207214355 L 6.853593826293945 23.89970207214355 L 3.814697265625e-06 11.94985294342041 L 6.853593826293945 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#aaa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aeb35e51d67250db7077aba31a6f81d4.svg";
export { ForwardRef as ReactComponent };